// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { tabsClasses } from '@mui/material/Tabs';
import React from 'react';
import { rem } from '../../tokens/conversions';
import { tabColors } from '../Tab/tabColors';
export var Tabs = function(mode) {
    var c = tabColors(mode);
    var override = {
        MuiTabs: {
            styleOverrides: {
                root: {
                    color: c.text,
                    // MUI defaults to 48px, taller than the 44px Tab, which drops the
                    // indicator below the tab and overflows a condensed AppBar.
                    minHeight: 'auto'
                },
                indicator: {
                    backgroundColor: c.selected.border,
                    height: rem(2)
                },
                vertical: _define_property({}, "& .".concat(tabsClasses.indicator), {
                    left: rem(0),
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    '& .MuiTabs-indicatorSpan': {
                        maxHeight: rem(20),
                        height: '100%',
                        width: '100%',
                        backgroundColor: c.selected.border
                    }
                })
            },
            defaultProps: {
                indicatorColor: 'secondary',
                textColor: 'inherit',
                TabIndicatorProps: {
                    children: /*#__PURE__*/ React.createElement("span", {
                        className: "MuiTabs-indicatorSpan"
                    })
                }
            }
        }
    };
    return override;
};

//# sourceMappingURL=Tabs.js.map